import { related, sourceIds } from './abilities__ignite-vs-inferno.mdx';

export { sourceIds, related };
export const table = {
  headers: ['比较重点', '玩法方向', '选择前核对'],
  rows: [
    ['Ignite', '武器攻击配合燃烧', '适合以武器攻击为主的搭配'],
    ['Inferno', '独立近距离火焰动作', '需要主动安排距离和能力输入'],
  ],
};
export const quickAnswer =
  'Ignite 能与武器攻击形成持续燃烧配合，更适合作为通用选择；Inferno 更偏近距离主动火焰攻击。按战斗习惯选择，不把两者换算成未经实测的 DPS 排名。';

## 火焰技能怎么选

Deserter 分组让你决定火焰是辅助武器，还是成为独立动作。先观察自己的主要攻击方式，再安排技能。

## Ignite 的玩法

Ignite 为武器攻击加入 Burn。武器攻击是主轴时，这种支持方式比较容易融入现有节奏。

## Inferno 的玩法

Inferno 是近距离火焰能力。若你愿意专门安排技能输入，并经常在合适距离战斗，可以考虑它。

## 搭配与取舍

武器支持和独立火焰动作没有在这里被换算成 DPS 排名。本站建议基于玩法，不声称实测最强。用[配装规划器](/build-planner)先记录替代方案，再决定是否在 The Gap 使用 Reset Item 重置。
